import React, { useEffect } from "react";
import config from "../Config";

export const useSounds = (
  setClips: React.Dispatch<React.SetStateAction<string[]>>
) => {
  useEffect(() => {
    let isRendered = true;
    const fetchSounds = () => {
      fetch(`${config.hegbotUrl}/sound_board/clips`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          return undefined;
        })
        .then((result) => {
          if (isRendered) {
            setClips(result.data.clips);
          }
        });
    };

    fetchSounds();
    const job = setTimeout(fetchSounds, 60000);

    return () => {
      isRendered = false;
      clearInterval(job);
    };
  }, [setClips]);
};
